import { ErrorMessage, Field, Formik, Form as FormikContainer } from "formik";
import React, { useCallback, useEffect, useRef, useState } from "react";
import WitmatesServices from "../../../http/witmates.service";
import { RegularButton } from "../../../Components/ButtonComp";
import { Col, Container, Form, Row } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import Typography from "../../../Components/Typography/Typography";
import styled from "styled-components";
import Svg from "../../../assets/Svgs/Svg";
import { useApp } from "../../../hooks/useApp";
import Loading from "../../../Components/Loading";

const { _applyJobApi, _applyJobSchema } = new WitmatesServices();
export default function JobApplyForm({ JobData, actionCb }) {
   const [loading, setLoading] = useState(false);
   const { setPopup } = useApp();
   const inputRef = useRef();
   const [fileInfo, setFileInfo] = useState(null);
   const [dataUrl, setDataUrl] = useState(null);
   const onDrop = useCallback((acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
         setFileInfo(file);
         const reader = new FileReader();
         reader.onload = (event) => {
            const dataUrl = event.target.result;
            setDataUrl(dataUrl);
         };
         reader.readAsDataURL(file);
      }
   }, []);
   const { getRootProps, getInputProps, isDragActive } = useDropzone({
      onDrop,
      accept: {
         "application/pdf": [".pdf"],
      },
   });
   const initialValues = {
      name: "",
      email: "",
      experience: "",
      skill: "",
      phone: "",
   };
   const onSubmit = (value, action) => {
      applyJob(value);
      actionCb();
   };
   const applyJob = (user) => {
      let formData = new FormData();
      formData.append("applicant[name]", user?.name);
      formData.append("applicant[email]", user?.email);
      formData.append("applicant[job_id]", JobData?.id);
      formData.append("applicant[experience]", user?.experience);
      formData.append("applicant[skill]", user?.skill);
      formData.append("applicant[phone]", user?.phone);
      formData.append("applicant[resume]", dataUrl);
      _applyJobApi(formData, (loading, data, error) => {
         setLoading(loading);
         if (data) {
            setFileInfo(null);
            setPopup({
               isOpen: true,
               content: (
                  <>
                     <span style={{ color: "#FF5101" }}>Thank you</span>
                     <br /> Your submission has been received.
                  </>
               ),
               cb: () => console.log(""),
            });
         }
         if (error) console.log(error);
      });
   };
   useEffect(() => {
      return () => {};
   }, []);

   return (
      <JobApplyFormCss>
         <Container fluid style={{ paddingLeft: "0px", paddingRight: "0px" }}>
            <Loading loading={loading} size="5px" color="white" height="50vh" background="#0E0E0E">
               <Row className="align-items-center">
                  <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                     <div className="container-fluid bg-white description-container">
                        <div className="row bg-black p-3" style={{ borderRadius: "5px" }}>
                           <div className="col-12 col-sm-12 col-md-12 col-lg-12 colorWhite">
                              <h3 className="fs30 fBold">
                                 <span style={{ color: "#FF5101" }}>{JobData?.designation}</span>
                              </h3>
                              <p className="fs18">Exp: 3+ Years</p>
                           </div>
                           <div className="col-12 col-sm-12 col-md-12 col-lg-12 colorWhite">
                              <h3 className="font-22 fBold text-uppercase" style={{ color: "#FF5101" }}>
                                 Skills :
                              </h3>
                              <p className="fs18">{JobData?.technology}</p>
                           </div>
                        </div>

                        <h1 className="py-3 mt-2">
                           Job <span style={{ color: "#FF5101" }}> Description:</span>
                        </h1>

                        <div className="p-2">
                           <div
                              style={{ height: "354px", overflowY: "scroll" }}
                              dangerouslySetInnerHTML={{
                                 __html: (JobData?.job_description || "").replace(/\r\n/g, "<br />"),
                              }}></div>
                        </div>
                     </div>
                  </Col>
                  <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                     <Formik className="container-fluid bg-black" validationSchema={_applyJobSchema} initialValues={initialValues} onSubmit={onSubmit}>
                        {(formik) => (
                           <FormikContainer className="container-fluid my-2 pt-3">
                              <div className="row g-3">
                                 <div className="col-12">
                                    <Form.Group>
                                       <Field as={Form.Control} id="name" type="text" placeholder="Enter your name" className="inputBorder bRadiusNone" name="name" ref={inputRef} />
                                       <ErrorMessage component="small" className="text-error" name="name" />
                                    </Form.Group>
                                 </div>
                                 <div className="col-12">
                                    <Form.Group>
                                       <Field as={Form.Control} id="email" type="email" placeholder="Enter your email" className="inputBorder bRadiusNone" name="email" />
                                       <ErrorMessage component="small" className="text-error" name="email" />
                                    </Form.Group>
                                 </div>
                                 <div className="col-12">
                                    <Form.Group>
                                       <Field as={Form.Control} id="phone" type="phone" placeholder="Enter your mobile no" className="inputBorder bRadiusNone" name="phone" />
                                       <ErrorMessage component="small" className="text-error" name="phone" />
                                    </Form.Group>
                                 </div>
                                 <div className="col-12">
                                    <Form.Group>
                                       <Field as={Form.Control} id="experience" type="text" placeholder="Enter your experience" className="inputBorder bRadiusNone" name="experience" />
                                       <ErrorMessage component="small" className="text-error" name="experience" />
                                    </Form.Group>
                                 </div>
                                 <div className="col-12">
                                    <Form.Group>
                                       <Field as={Form.Control} id="skill" type="skill" placeholder="Enter your skills" className="inputBorder bRadiusNone" name="skill" />
                                       <ErrorMessage component="small" className="text-error" name="skill" />
                                    </Form.Group>
                                 </div>
                                 <div className="col-12">
                                    <div className="p-5 text-center file-uploader d-flex align-items-center justify-content-center" {...getRootProps()}>
                                       <input {...getInputProps()} accept="application/pdf" />
                                       {isDragActive || fileInfo ? (
                                          <div>
                                             <p className="text-white">{fileInfo?.path}</p>
                                             <RegularButton btnText={<span className="text-white font-18">Reupload</span>} type="button" fullWidth noIcon />
                                          </div>
                                       ) : (
                                          <div>
                                             <Typography element="span" className="font-18" color="#F1F1F1" fontWeight={400} DMSans>
                                                Upload Your Resume
                                             </Typography>
                                             <div className="font-14 text-white position-relative my-2">
                                                <span className="line" style={{ left: "0px" }}></span>
                                                Or
                                                <span className="line" style={{ right: "0px" }}></span>
                                             </div>
                                             <RegularButton btnText={<span className="text-white font-18">Browse Files {Svg.whiteArrow}</span>} type="button" fullWidth noIcon />
                                          </div>
                                       )}
                                    </div>
                                 </div>
                                 <div className="col-12 py-4">
                                    <RegularButton btnText={<span className="text-white font-18">APPLY NOW {Svg.whiteArrow}</span>} type="submit" fullWidth noIcon />
                                 </div>
                              </div>
                           </FormikContainer>
                        )}
                     </Formik>
                  </Col>
               </Row>
            </Loading>
         </Container>
      </JobApplyFormCss>
   );
}

const JobApplyFormCss = styled.div`
   .form-control {
      background: #0e0e0e;
      color: white;
      border: 1px solid white !important;
      padding: 0px 25px 0px 25px;
      height: 56px;
   }
   .form-control::placeholder {
      color: white;
   }
   .file-uploader {
      border: 1.18px solid white !important;
      min-height: 165px;
   }
   label {
      color: white !important;
   }
   .line {
      width: 41%;
      display: block;
      border: 1px solid white;
      position: absolute;
      top: 10px;
   }
   .description-container {
      padding: 35px;
      border-radius: 5px;
      min-height: 733px;
   }
   @media (max-width: 992px) {
      .description-container {
         padding: 20px;
      }
      .item-container {
         padding: 8px !important;
      }
   }
   ::-webkit-scrollbar {
      width: 1px;
   }
`;
